module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-BoldItalic.b826102.woff";